/** Shared search/filter helpers for metahuman roster cards (My Patients). */

export function asText(value) {
  return value == null ? '' : String(value);
}

export function detailLines(option) {
  if (!option) return [];
  const lines = [];
  if (asText(option.gender).trim()) {
    lines.push({ label: 'Sex / gender', value: asText(option.gender).trim() });
  }
  if (asText(option.age).trim()) {
    lines.push({ label: 'Age', value: asText(option.age).trim() });
  }
  if (asText(option.race).trim()) {
    lines.push({ label: 'Race', value: asText(option.race).trim() });
  }
  if (option.heightCm != null) {
    lines.push({ label: 'Height', value: `${option.heightCm} cm` });
  }
  if (option.weightKg != null) {
    lines.push({ label: 'Weight', value: `${option.weightKg} kg` });
  }
  if (option.bmi != null) {
    lines.push({ label: 'BMI', value: String(option.bmi) });
  }
  if (asText(option.idleAnimations).trim()) {
    lines.push({ label: 'Idle animations', value: asText(option.idleAnimations).trim() });
  }
  return lines;
}

export function optionSearchHaystack(option) {
  return [
    option?.name,
    option?.gender,
    option?.age,
    option?.race,
    option?.heightCm,
    option?.weightKg,
    option?.bmi,
    option?.idleAnimations,
  ].map(asText).join(' ').toLowerCase();
}

export function filterCharacterOptions(options, search) {
  const list = Array.isArray(options) ? options : [];
  const q = asText(search).trim().toLowerCase();
  if (!q) return list;
  return list.filter((option) => optionSearchHaystack(option).includes(q));
}

export function findCharacterOption(options, { personaId, characterId } = {}) {
  const list = Array.isArray(options) ? options : [];
  if (personaId != null && personaId !== '') {
    const byPersona = list.find((option) => String(option.personaId) === String(personaId));
    if (byPersona) return byPersona;
  }
  if (characterId != null && characterId !== '') {
    return list.find((option) => String(option.characterId) === String(characterId)) || null;
  }
  return null;
}
